import { render, staticRenderFns } from "./xitonghuifu.vue?vue&type=template&id=b6285c5a&"
import script from "./xitonghuifu.vue?vue&type=script&lang=js&"
export * from "./xitonghuifu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports